import React from 'react'

import useVideoContext from 'hooks/useVideoContext/useVideoContext'

import LeftControlBarTab from '../LeftControlBarTab'

const imgProps = {
    alt: 'screenshare-icon',
    src: '/assets/revamp/screenshare.new.svg',
    height: '100%',
    width: '100%',
}

const Screenshare = ({ rightControl }) => {
    const { screenShare } = useVideoContext()
    const { isSharing, toggleScreenShare, isDisabled } = screenShare

    return (
        <LeftControlBarTab
            iconProps={imgProps}
            isEnabled={isSharing}
            isDisabled={isDisabled}
            onClick={toggleScreenShare}
            title="screenshare"
            tooltipPlacement="bottom"
            rightControl={rightControl}
            className="hover-here"
        />
    )
}

export default Screenshare
